import MenuDeals from './MenuDeals'

export default MenuDeals
